import { arrayIncludesNumber } from "./toolsHelper";
import { shouldApplyDedusa } from "./DeductibleRules";

/**
 * Which optional structural-benefit fields the Coverage Options step should
 * render, given the benefits already selected. Mirrors the isValidStep(4)
 * block inside useSteps.jsx's benefitsGenerator (which additionally gates the
 * quoter's wizard step-navigation, so it stays untouched) but is usable
 * standalone by any quote-shaped form.
 */
export const getCoverageOptionsVisibleFields = (selectedBenefitsIds = {}, isCountryResidenceDeductible = false) => {
    const visible = ["geogrcov", "maxcovpipoly", "dednonusa", "coinsurance"];

    if (!arrayIncludesNumber(Object.values(selectedBenefitsIds), "coinsurance_no")) {
        visible.push("maxcoinoop");
    }

    if (!Object.values(selectedBenefitsIds).includes("wwltd") && selectedBenefitsIds["geogrcov"]) {
        visible.push("provdnet");
    }

    if (shouldApplyDedusa(selectedBenefitsIds, isCountryResidenceDeductible)) {
        visible.push("dedusa");
    }

    return visible;
};
